import * as types from '../mutation-types'
import router from '../../router'
import * as api from '../api'
import _ from 'lodash'

const state = {
  device: {},
  devices: [],
  device_types: [],
  device_types_for_dropdown: [],
  device_sip_types: [],
  device_sip_types_for_dropdown: [],
  sort_by: '',
  sort_by_direction: ''
}

const getters = {
  singleDevice: state => state.device,
  allDevices: state => state.devices,
  allDeviceTypes: state => state.device_types,
  allDeviceTypesForDropdown: state => state.device_types_for_dropdown,
  allDeviceSipTypes: state => state.device_sip_types,
  allDeviceSipTypesForDropdown: state => state.device_sip_types_for_dropdown
}

const actions = {
  getDevices ({ commit }) {
    api.instance.get('devices')
      .then(function (response) {
        const devices = response.data.devices
        commit(types.RECEIVE_DEVICES, devices)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  sortDevices ({ commit }, sortBy) {
    if (sortBy == null) {
      sortBy = 'name'
    }

    commit(types.SORT_DEVICES, sortBy)
  },
  getDevice ({ commit }, deviceId) {
    api.instance.get('devices/' + deviceId)
      .then(function (response) {
        const device = response.data.device
        commit(types.RECEIVE_DEVICE, device)
      })
  },
  getDeviceTypes ({ commit }) {
    if (!Array.isArray(state.device_types) || !state.device_types.length) {
      api.instance.get('device_types')
        .then(function (response) {
          const deviceTypes = response.data.device_types
          commit(types.RECIEVE_DEVICE_TYPES, deviceTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getDeviceSipTypes ({ commit }) {
    if (!Array.isArray(state.device_sip_types) || !state.device_sip_types.length) {
      api.instance.get('device_sip_types')
        .then(function (response) {
          const deviceSipTypes = response.data.device_sip_types
          commit(types.RECEIVE_DEVICE_SIP_TYPES, deviceSipTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addEditDevice ({ commit, state, rootGetters }, data) {
    let device = data.device

    device.site_id = rootGetters.scopedSiteId

    if (device.device_type_id === 1 ||
      device.device_type_id === 3) {
      device.extension = 0
    } else if (device.device_type_id === 2) {
      device.port = 0

      if (device.device_sip_type_id !== 6) {
        device.intercom_external_sip_id = 0
      }
    }

    if (device.device_type_id !== 2) {
      device.device_sip_type_id = 0
      device.intercom_external_sip_id = 0
    }

    if (device.name === '') {
      alert('Name required!')
      return
    }

    // If a visual/ios device, we want to confirm that the password field is correct.
    if ([5,6].includes(device.device_type_id) && device.password.length > 15)
    {
      alert('Password cannot be greater than 15 characters')
      return
    }
    if ([5,6].includes(device.device_type_id) && device.password.length < 4)
    {
      alert('Password cannot be less than 4 characters')
      return
    }

    if (device.device_type_id === 2) {
      if (device.extension === 0) {
        alert('Extension required!')
        return
      }

      if (device.voip) {
        for (let i = 0; i < device.device_attributes.length; i++) {
          if (device.device_attributes[i].attr_name === 'DID Number' || device.device_attributes[i].attr_name === 'Forward Number') {
            device.device_attributes[i].attr_str = device.device_attributes[i].attr_str.replace(/\s/g, '')
          }
        }
      }

      if (device.device_sip_type_id === 6 && device.intercom_external_sip_id === '0') {
        alert('Intercom external sip required!')
        return
      }
    }

    if (device.device_id === 0) {
      api.instance.post('devices', device)
        .then(function (response) {
          if (response.data.success === 'true') {
            device = response.data.device[0]
            commit(types.ADD_DEVICE, device)
            router.push({ name: data.push_on_success })
          } else {
            if (response.data.message)
              alert(response.data.message)
            else
              alert("An unexpected error occurred. Please try again later.")
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      let deviceZones = []
      for (let i = 0; i < device.zones_selected.length; i++) {
        deviceZones.push({
          zone_id: device.zones_selected[i].value,
          name: device.zones_selected[i].label
        })
      }
      device.device_zones = deviceZones

      api.instance.put('devices/' + device.device_id, device)
        .then(function (response) {
          if (response.data.success === 'true') {
            device = response.data.device[0]
            commit(types.EDIT_DEVICE, device)
            router.push({ name: data.push_on_success })
          } else {
            if (response.data.message)
              alert(response.data.message)
            else
              alert("An unexpected error occurred. Please try again later.")
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteDevice ({ commit }, device) {
    api.instance.delete('devices/' + device.device_id)
      .then(function (response) {
        commit(types.DELETE_DEVICE, device)
      })
  }
}

const mutations = {
  [types.RECEIVE_DEVICES] (state, devices) {
    // reset sorting
    state.sort_by = ''
    state.sort_by_direction = ''

    state.devices = _.orderBy(devices, ['site_id', 'name'])
  },
  [types.SORT_DEVICES] (state, sortBy) {
    let direction = 'asc'

    if (sortBy === state.sort_by) {
      if (state.sort_by_direction === 'asc') {
        direction = 'desc'
      } else {
        direction = 'asc'
      }
    }

    state.devices = _.orderBy(state.devices, ['site_id', sortBy], direction)
    state.sort_by = sortBy
    state.sort_by_direction = direction
  },
  [types.RECEIVE_DEVICE] (state, device) {
    device.zones_selected = []
    for (let i = 0; i < device.device_zones.length; i++) {
      device.zones_selected.push({
        value: device.device_zones[i].zone_id,
        label: device.device_zones[i].name
      })
    }
    state.device = device
  },
  [types.RECIEVE_DEVICE_TYPES] (state, deviceTypes) {
    state.device_types = deviceTypes

    for (let i = 0; i < state.device_types.length; i++) {
      state.device_types_for_dropdown.push({
        value: state.device_types[i].device_type_id,
        label: state.device_types[i].name
      })
    }
  },
  [types.RECEIVE_DEVICE_SIP_TYPES] (state, deviceSipTypes) {
    state.device_sip_types = deviceSipTypes

    for (let i = 0; i < state.device_sip_types.length; i++) {
      state.device_sip_types_for_dropdown.push({
        value: state.device_sip_types[i].device_sip_type_id,
        label: state.device_sip_types[i].name
      })
    }
  },
  [types.ADD_DEVICE] (state, device) {
    state.devices.push(device)
  },
  [types.EDIT_DEVICE] (state, device) {
    let deviceToEdit = state.devices.find(
      function (ele) {
        if (ele.device_id === device.device_id) {
          return true
        }
      }
    )
    let index = state.devices.indexOf(deviceToEdit)
    state.devices[index] = device
  },
  [types.DELETE_DEVICE] (state, device) {
    let deviceToDelete = state.devices.find(
      function (ele) {
        if (ele.device_id === device.device_id) {
          return true
        }
      }
    )
    let index = state.devices.indexOf(deviceToDelete)
    state.devices.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
